import Vuex from 'vuex';
import Data from './Data';
import App from './App';

const store = new Vuex.Store({
  modules: {
    Data,
    App,
  },
  state: {},
  actions: {},
  mutations: {},
  getters: {},
});

export default store;
